var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 97.92 102.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m18.15,102.79c-6.36,0-11.41-2.55-15.01-7.58-2.08-2.9-3.13-6.24-3.13-9.93V22.48C.01,13.38,7.13,5.72,16.2,5.04c.67-.05.91-.31.86-.97-.03-.48-.02-.96.04-1.44C17.29,1.14,18.52.03,20.03,0h0c1.61,0,2.84,1.06,3.06,2.57.07.49.09.98.11,1.49,0,.24.04.84.04.84h9.23v-.6c0-.35,0-.69,0-1.03.03-1.93,1.28-3.28,3.04-3.28,1.82,0,3.04,1.32,3.05,3.27,0,1.65.06,1.7,1.71,1.7h7.64s0-.7,0-.7c0-.41,0-.79,0-1.17.03-1.76,1.31-3.09,2.98-3.1,1.79,0,3.08,1.32,3.11,3.13,0,.36,0,.73,0,1.12v.68s.46.02.46.02c.22.01.42.02.61.02h3.91c1.17,0,2.33,0,3.49.01h0c.36,0,.57-.07.71-.21.13-.14.18-.35.15-.66-.03-.35-.03-.73,0-1.2.11-1.67,1.37-2.89,3.01-2.91,1.65,0,2.92,1.2,3.07,2.85.03.29.05.67,0,1.03-.05.41,0,.67.16.85.16.18.41.26.81.26,1.27-.03,2.46-.04,3.66-.04s2.49.01,3.73.03h0c.4,0,.64-.07.78-.22.15-.16.21-.4.19-.79-.03-.64,0-1.18.1-1.66.3-1.36,1.51-2.31,2.94-2.31.08,0,.17,0,.25,0,1.49.11,2.68,1.32,2.76,2.81.04.76.04,1.37,0,1.94-.04.62.24.84.75,1.02,6.89,2.4,10.98,7.27,12.17,14.46.16.97.16,1.98.16,2.96,0,20.55.02,41.07,0,61.6,0,8.92-5.8,16.02-14.41,17.67-1.05.2-2.24.3-3.62.3-11.24,0-22.48,0-33.72.01-9.33,0-18.67,0-28,0h-.01ZM6.09,47.73c0,12.44,0,24.87,0,37.31,0,6.63,5.03,11.63,11.68,11.63h62.53c.52,0,1.13-.02,1.72-.12,5.83-1,9.75-5.64,9.75-11.55,0-12.19,0-53.24,0-53.24H6.09v15.97ZM16.32,11.16c-2.68,0-5.38,1.44-7.41,3.96-2.43,3.01-3.45,6.88-2.7,10.36l.02.09h85.46l.02-.1c.94-5.77-2.43-12.45-6.69-13.25l-.13-.02s-.04.51-.04.62c-.08,1.85-1.32,3.14-3.01,3.14-1.79,0-3.07-1.39-3.08-3.29v-1.55h-9.35v.12c0,.23,0,.46.01.68.01.47.03.92-.03,1.36-.19,1.55-1.45,2.67-2.99,2.67-1.67-.04-2.92-1.25-3.04-2.87-.02-.31-.05-.72,0-1.12.03-.32-.01-.54-.15-.68-.14-.15-.36-.22-.72-.22-1.24.01-2.45.02-3.65.02h-3.96c-.16,0-.32.02-.5.04l-.37.04v1.47c0,1.96-1.21,3.29-3.01,3.32h0c-1.81,0-3.06-1.37-3.08-3.33,0-.29,0-1.55,0-1.55h-7.64c-1.65,0-1.7.05-1.71,1.69-.01,1.81-1.26,3.16-2.97,3.19h0c-1.76,0-3.07-1.35-3.12-3.15,0-.34,0-.68,0-1.03v-.64s-9.24,0-9.24,0c0,0-.02.56-.03.78-.01.46-.03.89-.08,1.32-.19,1.57-1.44,2.72-2.96,2.72-1.7-.04-2.97-1.26-3.07-2.91-.02-.38-.02-.76-.01-1.16v-.68s-.1,0-.1,0c-.22-.02-.43-.03-.64-.03Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 24.01,
    y: 42.72,
    width: 8.57,
    height: 8.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 24.02,
    y: 60.74,
    width: 8.55,
    height: 8.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 65.3,
    y: 60.73,
    width: 8.54,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 65.33,
    y: 42.69,
    width: 8.55,
    height: 8.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 44.67,
    y: 42.71,
    width: 8.54,
    height: 8.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 44.69,
    y: 60.74,
    width: 8.54,
    height: 8.55
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m32.22,87.36c-1.74-.01-3.47-.01-5.21-.02h-2.84s-.06-.02-.11-.04l-.04-.02v-8.51h8.61s0,6.53,0,8.01c0,.2,0,.4-.09.49-.06.06-.16.09-.31.09h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 65.3,
    y: 78.76,
    width: 8.55,
    height: 8.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 44.69,
    y: 78.75,
    width: 8.51,
    height: 8.56
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.0d9ae21c8bfb05e33b76264cdefaa938.svg";
export { ForwardRef as ReactComponent };